<template>
    <v-container>
        <v-row dense>
            <v-row>
                <v-col cols="11">
                    <v-card-title class="titulopagina">
                        REPORTE CONSOLIDADO ANUAL
                    </v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                        <v-icon color="blue" large>help</v-icon>
                    </v-alert>
                </v-col>
            </v-row>
            <modal-ayuda></modal-ayuda>
            <v-col cols="12">
                <v-card color="#C0D5ED">
                    <v-card-actions>
                        <v-col cols="3">
                            <v-select
                                v-model="anio"
                                label="Seleccione año para reporte"
                                filled
                                outlined
                                :items="anios()"
                                @change="cargarDatos"
                            ></v-select>
                        </v-col>
                        <v-col cols="6"></v-col>
                        <v-col>
                            <v-btn color="green darken 1" dark @click="download">Generar Excel</v-btn>
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" class="mb-4">
                <v-card color="#C0D5ED" dark>
                    <v-card-title class="title">
                        Resumen Producción Planta Harina
                    </v-card-title>
                    <v-row class="px-4 pt-6 pb-2">
                        <v-col>
                            <v-card>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th v-for="enc in encabezado" class="th text-center">{{ enc }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in resumen_planta_harina" class="tr">
                                            <template>
                                                <td class="td--detalle">{{ fila.detalle }}</td>
                                                <td class="td text-right" v-for="index in 12">
                                                    <template v-if="fila.detalle.includes('Proteína')">
                                                        {{ fila[index] | formatear_porcentaje }}
                                                    </template>
                                                    <template v-else-if="fila[index] % 1 == 0">
                                                        {{ fila[index] | formatear_miles }}
                                                    </template>
                                                    <template v-else>{{ fila[index] }}</template>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>

            <v-col cols="12" class="mb-4">
                <v-card color="#C0D5ED" dark>
                    <v-card-title class="title">
                        Resumen Producción Planta Hidrolizado
                    </v-card-title>
                    <v-row class="px-4 pt-6 pb-2">
                        <v-col>
                            <v-card>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th v-for="enc in encabezado" class="th text-center">{{ enc }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in resumen_planta_hidrolizado" class="tr">
                                            <template>
                                                <td class="td--detalle">{{ fila.detalle }}</td>
                                                <td class="td text-right"><template v-if="fila[1] % 1 == 0">{{ fila[1] | formatear_miles }}</template><template v-else>{{ fila[1] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[2] % 1 == 0">{{ fila[2] | formatear_miles }}</template><template v-else>{{ fila[2] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[3] % 1 == 0">{{ fila[3] | formatear_miles }}</template><template v-else>{{ fila[3] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[4] % 1 == 0">{{ fila[4] | formatear_miles }}</template><template v-else>{{ fila[4] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[5] % 1 == 0">{{ fila[5] | formatear_miles }}</template><template v-else>{{ fila[5] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[6] % 1 == 0">{{ fila[6] | formatear_miles }}</template><template v-else>{{ fila[6] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[7] % 1 == 0">{{ fila[7] | formatear_miles }}</template><template v-else>{{ fila[7] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[8] % 1 == 0">{{ fila[8] | formatear_miles }}</template><template v-else>{{ fila[8] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[9] % 1 == 0">{{ fila[9] | formatear_miles }}</template><template v-else>{{ fila[9] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[10] % 1 == 0">{{ fila[10] | formatear_miles }}</template><template v-else>{{ fila[10] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[11] % 1 == 0">{{ fila[11] | formatear_miles }}</template><template v-else>{{ fila[11] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[12] % 1 == 0">{{ fila[12] | formatear_miles }}</template><template v-else>{{ fila[12] }}</template></td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>

            <v-col cols="12" class="mb-4">
                <v-card color="#C0D5ED" dark>
                    <v-card-title class="title">
                        Resumen Combustible FO N6
                    </v-card-title>
                    <v-row class="px-4 pt-6 pb-2">
                        <v-col>
                            <v-card>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th v-for="enc in encabezado" class="th text-center">{{ enc }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in resumen_combustible" class="tr">
                                            <template>
                                                <td class="td--detalle">{{ fila.detalle }}</td>
                                                <td class="td text-right"><template v-if="fila[1] % 1 == 0">{{ fila[1] | formatear_miles }}</template><template v-else>{{ fila[1] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[2] % 1 == 0">{{ fila[2] | formatear_miles }}</template><template v-else>{{ fila[2] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[3] % 1 == 0">{{ fila[3] | formatear_miles }}</template><template v-else>{{ fila[3] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[4] % 1 == 0">{{ fila[4] | formatear_miles }}</template><template v-else>{{ fila[4] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[5] % 1 == 0">{{ fila[5] | formatear_miles }}</template><template v-else>{{ fila[5] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[6] % 1 == 0">{{ fila[6] | formatear_miles }}</template><template v-else>{{ fila[6] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[7] % 1 == 0">{{ fila[7] | formatear_miles }}</template><template v-else>{{ fila[7] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[8] % 1 == 0">{{ fila[8] | formatear_miles }}</template><template v-else>{{ fila[8] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[9] % 1 == 0">{{ fila[9] | formatear_miles }}</template><template v-else>{{ fila[9] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[10] % 1 == 0">{{ fila[10] | formatear_miles }}</template><template v-else>{{ fila[10] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[11] % 1 == 0">{{ fila[11] | formatear_miles }}</template><template v-else>{{ fila[11] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[12] % 1 == 0">{{ fila[12] | formatear_miles }}</template><template v-else>{{ fila[12] }}</template></td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>

            <v-col cols="12" class="mb-4">
                <v-card color="#C0D5ED" dark>
                    <v-card-title class="title">
                        Resumen EE y Generación Eléctrica
                    </v-card-title>
                    <v-row class="px-4 pt-6 pb-2">
                        <v-col>
                            <v-card>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th v-for="enc in encabezado" class="th text-center">{{ enc }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in resumen_energia" class="tr">
                                            <template>
                                                <td class="td--detalle">{{ fila.detalle }}</td>
                                                <td class="td text-right"><template v-if="fila[1] % 1 == 0">{{ fila[1] | formatear_miles }}</template><template v-else>{{ fila[1] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[2] % 1 == 0">{{ fila[2] | formatear_miles }}</template><template v-else>{{ fila[2] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[3] % 1 == 0">{{ fila[3] | formatear_miles }}</template><template v-else>{{ fila[3] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[4] % 1 == 0">{{ fila[4] | formatear_miles }}</template><template v-else>{{ fila[4] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[5] % 1 == 0">{{ fila[5] | formatear_miles }}</template><template v-else>{{ fila[5] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[6] % 1 == 0">{{ fila[6] | formatear_miles }}</template><template v-else>{{ fila[6] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[7] % 1 == 0">{{ fila[7] | formatear_miles }}</template><template v-else>{{ fila[7] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[8] % 1 == 0">{{ fila[8] | formatear_miles }}</template><template v-else>{{ fila[8] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[9] % 1 == 0">{{ fila[9] | formatear_miles }}</template><template v-else>{{ fila[9] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[10] % 1 == 0">{{ fila[10] | formatear_miles }}</template><template v-else>{{ fila[10] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[11] % 1 == 0">{{ fila[11] | formatear_miles }}</template><template v-else>{{ fila[11] }}</template></td>
                                                <td class="td text-right"><template v-if="fila[12] % 1 == 0">{{ fila[12] | formatear_miles }}</template><template v-else>{{ fila[12] }}</template></td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data: () => ({
        /* encabezado: [
                { text: 'Detalle', align: 'center',    sortable: true,     value: 'detalle',             class: 'cabecera',},
                { text: 'Enero', align: 'center',    sortable: true,     value: '1',     class: 'cabecera',},
                { text: 'Febrero',      align: 'center',    sortable: true,     value: '2',    class: 'cabecera',},
                { text: 'Marzo', align: 'center',    sortable: true,     value: '3',      class: 'cabecera',},
                { text: 'Abril',         align: 'center',    sortable: true,     value: '4',              class: 'cabecera',},
                { text: 'Mayo',     align: 'center',    sortable: true,     value: '5',          class: 'cabecera',},
                { text: 'Junio',     align: 'center',    sortable: true,     value: '6',          class: 'cabecera',},
                { text: 'Julio',     align: 'center',    sortable: true,     value: '7',          class: 'cabecera',},
                { text: 'Agosto',     align: 'center',    sortable: true,     value: '8',          class: 'cabecera',},
                { text: 'Septiembre',     align: 'center',    sortable: true,     value: '9',          class: 'cabecera',},
                { text: 'Octubre',     align: 'center',    sortable: true,     value: '10',          class: 'cabecera',},
                { text: 'Noviembre',     align: 'center',    sortable: true,     value: '11',          class: 'cabecera',},
                { text: 'Diciembre',     align: 'center',    sortable: true,     value: '12',          class: 'cabecera',},
            ], */
        encabezado: ['Detalle', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        resumen_planta_harina: [],
        resumen_planta_hidrolizado: [],
        resumen_combustible: [],
        resumen_energia: [],
        anio: 0,
    }),
    filters: {
        formatear_porcentaje(value) {
            if(!value) return `0%`;
            
            if(typeof value === 'string') {
                if(value.includes(',')) value = value.replace(',', '.');
                value = Number.parseFloat(value);
            }
        
            if(value % 1 === 0)
                return `${value}%`;

            return `${value.toFixed(2)}%`;
        },
    },
    mounted() {
        this.anio = parseInt(this.moment().format('YYYY'));
        this.cargarDatos();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte Consolidado Anual`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un resumen de la producción anual de cada planta y de la recepción y consumo de combustibles/energía. Se puede seleccionar el año para obtener un reporte o exportar los reportes a un Excel con el botón "Generar Excel".`},
                {   tipo:`label`,   texto:`Cada resumen se muestra en una tabla dividida por cada mes del año y el detalle que corresponde.`},
            ];
            
            Event.$emit('mostrar_alert', jiji);
        },
        async cargarDatos() {
            this.mostrarLoading({titulo:'Cargando Datos de Producción Anual...',color:'green'})
            const url = `${this.base_url}produccion_diaria/produccion_anual`;
            const data = { anio: this.anio, excel: false }
            await this.axios.post(url, data, this.headers).then(res => {
                
                const response_data = res.data.data;
                console.log(response_data);

                let detalle = {
                    "Proyectado": "Proyectado", "Recepcion": "Recepción", "Procesado": "Procesado", 
                    "Saldo": "Saldo en Pozos", "Coho": "% Coho", "Drenado": "% Drenado", 
                    "ProduccionH": "Producción Harina", "RendimientoH": "% Rendimiento", "Proteina68": "Proteína >68%", 
                    "Proteina67": "Proteína 66-68%", "Proteina66": "Proteína <66%", "DespachoH": "Despachos Harina", 
                    "ProduccionA":"Producción Aceite", "RendimientoA": "% Rendimiento", "AcidezA": "% Acidez", 
                    "DespachoA": "Despachos Aceite", "HOHarina": "Horas Operativas"
                }

                if(this.resumen_planta_harina.length > 0)
                    this.resumen_planta_harina = [];
                this.rellenarDatos(detalle, this.resumen_planta_harina, response_data.my_collect);

                detalle = {
                    "Proyectado": "Proyectado", "Recepcion": "Recepción", "Procesado": "Procesado", 
                    "Saldo": "Saldo en TKs", "ProduccionA": "Producción Aceite",
                    "RendimientoA": "% Rendimiento", "AcidezA": "% Acidez", 
                    "DespachoA": "Despachos Aceite", "ProduccionC": "Producción Concentrado",
                    "RendimientoC": "% Rendimiento", "DespachoC": "Despachos Concentrado",
                    "DespachoF": "Despachos Fertilizante", "HOHidrolizado": "Horas Operativas"
                }

                if(this.resumen_planta_hidrolizado.length > 0)
                    this.resumen_planta_hidrolizado = [];
                this.rellenarDatos(detalle, this.resumen_planta_hidrolizado, response_data.my_collect2);

                detalle = {
                    "RCombustible": "Recepción", "CCombustible": "Consumo", 
                    "StockCombustible": "Stock", "ConsumoE": "Consumo Específico"
                }

                if(this.resumen_combustible.length > 0)
                    this.resumen_combustible = [];
                this.rellenarDatos(detalle, this.resumen_combustible, response_data.my_collect3);

                detalle = {
                    "EnergiaSaesa": "Saesa Kw/hr", "EnergiaGSaesa": "Generador Saesa Kw/hr", 
                    "EnergiaGCumming": "Generador Cumming Kw/hr", "ConsumoE": "Consumo Específico"
                }

                if(this.resumen_energia.length > 0)
                    this.resumen_energia = [];
                this.rellenarDatos(detalle, this.resumen_energia, response_data.my_collect4);

                console.log(this.resumen_planta_harina);
                console.log(this.resumen_planta_hidrolizado);
                console.log(this.resumen_combustible);
                console.log(this.resumen_energia);
                this.ocultarLoading();

            }).catch(error => {
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        rellenarDatos(detalle, listaARellenar, datos) {
            Object.entries(detalle).forEach(([key, value]) => {
                listaARellenar.push({
                    col: key,
                    detalle: value,
                })
            });

            datos.forEach(data => {
                if(typeof data.valor === "number" && !data.valor % 1 == 0) {
                    data.valor = data.valor.toString().replace(".", ",");
                }

                const idx = listaARellenar.findIndex(row => row.col === data.col);
                if(idx < 0) {
                    listaARellenar.push({
                        [data.mes]: data.valor,
                        col: data.col,
                        detalle: detalle[data.col]
                    });
                } else {
                    if(listaARellenar[idx].col === "Proyectado") {
                        data.valor = data.valor * 1000;
                    }
                    listaARellenar[idx][data.mes] = data.valor;
                }
            });
        },
        async download() {
            this.mostrarLoading({titulo:'Generando Excel...',color:'green'})
            const url = `${this.base_url}produccion_diaria/produccion_anual`;
            const data = { anio: this.anio }
            await this.axios.post(url, data, this.headers).then((response)=>{
                this.url_excel = response.data.url_excel;
                this.ocultarLoading();
                window.location.href = this.download_url.replace('bitacoras', 'plantillas') + this.url_excel;
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        anios() {
            const anioActual = parseInt(this.moment().format('YYYY'));
            //const anioActual = 2027;
            const anios = [];
            
            for(let i = anioActual; i >= 2022; i--) {
                anios.unshift(i);
            }
            
            return anios;
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'download_url']),
    },
    components: {
        'modal-ayuda': ModalAyudas,
    },
}
</script>

<style scoped>
    .td {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    .tr {
        background-color: #6D8DB7;
        color: #000;
    }
    .tr:hover {
        background-color: #5B78A7 !important;
    }
    .th {
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #243674 !important;
        color: #fff !important;
        font-size: 0.9em !important;
    }
    .td--detalle {
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #496296 !important;
        color: #fff !important;
    }
    .title {
        background-color:#6D8DB7;color:#fff !important; padding:0.3em 0.5em; border-radius:0.5em;
    }
    .select {
        padding: 1em;
        border: thin #243674 solid;
        border-radius: 1em;
    }
</style>